import { createAsyncThunk } from "@reduxjs/toolkit";
import { checklistDocumentUplodOptions } from "../../../api/settings";

export const checklistDocumentUplodOptionsAction = createAsyncThunk(
  "caseGeneralSettings/caseGeneralSettingsAction",
  async (values, { rejectWithValue, getState }) => {
    try {
      const result = await checklistDocumentUplodOptions(values);

      return result;
    } catch (error) {
      return rejectWithValue(error.message || "something went wrong");
    }
  },
);
